import { TileIndex } from "../../types";

export const BOMB_DIFFUSER_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 2, 2, 2, 2, 2, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 18, 0, 12, 0, 25, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 3, 3, 13, 13, 13, 13, 13, 1],
  [1, 15, 3, 26, 0, 27, 0, 13, 1],
  [1, 3, 3, 13, 13, 13, 13, 13, 1],
  [1, 13, 13, 13, 13, 13, 13, 13, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1],
];
